import React, { useState } from "react";
import "./Menu.css";

const Menu = ({ onNavigate, onLogout }) => {
  const [open, setOpen] = useState(false);

  const toggleMenu = () => setOpen(!open);

  const navigate = (page) => {
    onNavigate(page);
    setOpen(false);
  };

  const handleLogout = () => {
    // Limpa aba salva ao sair
    localStorage.removeItem("abaHome");
    localStorage.removeItem("abaUsuarios"); // opcional: limpa também a aba de usuários
    onNavigate("inicio"); // garante reset visual
    onLogout(); // chama o logout de verdade
  };

  return (
    <div className="menu-container">
      <div className="menu-icon" onClick={toggleMenu}>☰</div>

      {open && (
        <div className="menu-dropdown">
          <button onClick={() => navigate("inicio")}>🏠 Início</button>
          <button onClick={() => navigate("cadastros")}>👤 Cadastros</button>
          <button onClick={handleLogout}>🚪 Sair</button>
        </div>
      )}
    </div>
  );
};

export default Menu;
